import { z } from 'zod';
import { jMeetingList } from './meeting';
import { jSocialEventList } from './socialEvent';
import { jUserLittleSchema } from './user';
import { jArticleListSchema, jArticleLittleSchema } from './article';

export const calendarOldEventSchema = z.object({
    idArticle: z.number(),
    title: z.string(),
    start: z.string(),
    end: z.string(),
    url: z.string(),
    textColor: z.string().optional(),
    color: z.string().optional(),
    bgColor: z.string().optional(),
    backgroundColor: z.string().optional(),
    subscribe: z.boolean(),
});
export type CalendarOldEvent = z.infer<typeof calendarOldEventSchema>;

export const ensureIsCalendarOldEvent = (o: unknown): o is CalendarOldEvent => {
    return calendarOldEventSchema.safeParse(o).success;
};

export const calendarEventsExtension = z.object({
    maxdate: z.string().optional(),
    subscribers: jUserLittleSchema.array(),
    subscribersTotal: z.number(),
});

export type CalendarEventsExtension = z.infer<typeof calendarEventsExtension>;
export type CalendarCombinedEventsList =
    | (jMeetingList & CalendarEventsExtension)
    | (jSocialEventList & CalendarEventsExtension);

export const calendarEventAdditionalSchema = z.object({
    dateStart: z.string().optional(),
    dateEnd: z.string().optional(),
    allDay: z.boolean().optional(),
    backgroundColor: z.string().nullable().optional(),
    textColor: z.string().optional(),
    address: z.string().optional(),
});

export const calendarEventLittleAbstractTypeSchema = jArticleLittleSchema
    .merge(calendarEventAdditionalSchema)
    .passthrough();
export type CalendarEventLittleAbstractType = z.infer<typeof calendarEventLittleAbstractTypeSchema>;

export const calendarEventListAbstractTypeSchema = jArticleListSchema
    .merge(calendarEventAdditionalSchema)
    .passthrough();
export type CalendarEventListAbstractType = z.infer<typeof calendarEventListAbstractTypeSchema>;

export const eventStatusFilterSchema = z.enum(['subscribed', 'unanswered', 'refused']);
export type EventStatusFilter = z.infer<typeof eventStatusFilterSchema>;
